import Firebase from './Firebase';
import FirebaseContext, { FirebaseContextProvider } from './FirebaseContext';

export default Firebase;

export { FirebaseContext, FirebaseContextProvider };
